export const ru = {
    'sizes-title': 'Размеры'
};
